import _ from 'lodash';

export default {
  namespaced: true,
  state: {
    meta: {
      endOfYear: undefined,
      transactionFee: undefined,
      timezone: undefined,
      timeSettings: {
        from: '00:00',
        to: '23:59'
      },
      multipleRegoAllowed: false,
      bulkRegoAllowed: false,
      allowOfflinePayment: false,
    },
    scoringEvents: [],
    playerMovements: [],
    paymentSettings: {},
    aplyPaymentSettings: {},
    editAccount: {},
    paymentPreference: false,
    saleableItemTypes: [],
    memberTypes: [],
    misc: {},
    memberSettings: {
      createEnabled: false,
      addToTeamSettings: [
        { level: 2, name: 'Nationals', value: false },
        { level: 3, name: 'States', value: false },
        { level: 4, name: 'Associations', value: false },
        { level: 5, name: 'Clubs', value: false },
        { level: 6, name: 'Teams', value: false },
      ]
    },
    regoClearanceSettings: {
      transferWindows: []
    },
    deregistrationEmailRules: []
  },
  mutations: {
    updateMeta(state, payload) {
      state.meta = _.merge(state.meta, payload.meta);
      if (_.get(payload, 'editAccount')) state.editAccount = payload.editAccount;
      if (_.get(payload, 'paymentSettings')) state.paymentSettings = payload.paymentSettings;
      if (_.get(payload, 'applyPaymentSettings')) state.applyPaymentSettings = payload.applyPaymentSettings;
      if (_.get(payload, 'paymentPreference')) state.paymentPreference = payload.paymentPreference;
      if (_.get(payload, 'memberTypes')) state.memberTypes = payload.memberTypes;
      if (_.get(payload, 'scoringEvents')) state.scoringEvents = payload.scoringEvents;
      if (_.get(payload, 'playerMovements')) state.playerMovements = payload.playerMovements;
      if (_.get(payload, 'members')) state.memberSettings = payload.members;
      if (_.get(payload, 'regoClearanceSettings')) state.regoClearanceSettings = payload.regoClearanceSettings;
      if (_.get(payload, 'saleableItemTypes')) state.saleableItemTypes = payload.saleableItemTypes;
      if (_.get(payload, 'deregistrationEmailRules')) state.deregistrationEmailRules = payload.deregistrationEmailRules;
      if (_.get(payload, 'misc')) {
        state.misc = payload.misc;
        console.log('misc', state.misc);
      }
      console.log({
        meta: payload,
      });
    },
    updateApproveType(state, payload) {
      state.regoClearanceSettings.approveType = payload;
    },
    updateTransferWindows(state, payload) {
      state.regoClearanceSettings.transferWindows = payload;
    },
  },
  actions: {
    async setup({ commit }) {
      const res = await this._vm.$http.get('assemble/api/v1/admin/nationals/get/meta');
      if (res.data.data) commit('updateMeta', res.data.data);
    }
  },
  getters: {
    endOfYear(state) {
      return _.get(state, 'meta.endOfYear');
    },
    transactionFee(state) {
      return _.get(state, 'meta.transactionFee');
    },
    links(state) {
      return _.get(state, 'meta.links');
    },
    paymentPreference(state) {
      return _.get(state, 'paymentPreference', {});
    },
    allowOfflinePayment(state) {
      return _.get(state, 'meta.allowOfflinePayment', false);
    },
    paymentSettings(state) {
      return _.get(state, 'paymentSettings', {});
    },
    misc(state) {
      return _.get(state, 'misc', {});
    },
    editAccount(state) {
      return _.get(state, 'editAccount', {});
    },
    applyPaymentSettings(state) {
      return _.get(state, 'applyPaymentSettings', {});
    },
    memberTypes(state) {
      return _.get(state, 'memberTypes', []);
    },
    scoringEvents(state) {
      return _.get(state, 'scoringEvents', []);
    },
    playerMovements(state) {
      return _.get(state, 'playerMovements', []);
    },
    createEnabled(state) {
      return _.get(state, 'memberSettings.createEnabled');
    },
    addToTeamSettings(state) {
      return _.get(state, 'memberSettings.addToTeamSettings');
    },
    addToEventSettings(state) {
      return _.get(state, 'memberSettings.addToEventSettings');
    },
    expiryDateSettings(state) {
      return _.get(state, 'memberSettings.expiryDateSettings');
    },
    deregistrationRequestsSettings(state) {
      return _.get(state, 'memberSettings.deregistrationRequestsSettings');
    },
    memberRegistrationHistorySettings(state) {
      return _.get(state, 'memberSettings.memberRegistrationHistorySettings');
    },
    createMemberSettings(state) {
      return _.get(state, 'memberSettings.createMemberSettings');
    },
    accreditationSettings(state) {
      return _.get(state, 'memberSettings.accreditationSettings');
    },
    regoClearanceSettings(state) {
      return _.get(state, 'regoClearanceSettings');
    },
    timezone(state) {
      return _.get(state, 'meta.timezone', 'Australia/Sydney');
    },
    timeSettings(state) {
      return _.get(state, 'meta.timeSettings', { from: '00:00', to: '23:59' });
    },
    saleableItemTypes(state) {
      return _.get(state, 'saleableItemTypes', []);
    },
    multipleRegoAllowed(state) {
      return _.get(state, 'meta.multipleRegoAllowed');
    },
    bulkRegoAllowed(state) {
      return _.get(state, 'meta.bulkRegoAllowed');
    },
    teamPreferredTimeSlots(state) {
      return _.get(state, 'module.teamPreferredTimeSlots');
    },
  },
};
